import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              {/* Budding ML Engineer and Blockchain Enthusiast
               
              <br />
              <br />I am fluent in classics like
              <i>
                <b className="purple"> C++ and Python</b>
              </i>
              <br />
              <br />
              My field of Interest's are building new &nbsp;
              <i>
                <b className="purple">Blockchain Applications </b> and
                also in areas related to{" "}
                <b className="purple">
                  Deep Learning and Optical Character Recognition.
                </b>
              </i>
              <br />
              <br />
              Whenever possible, I also apply my passion for developing products
              with <b className="purple">Hyperledger, Data Scraping</b> and
              <i>
                <b className="purple">
                  {" "}
                  Machine Learning and Deep LearningFrameworks
                </b>
              </i>
              &nbsp; like
              <i>
                <b className="purple"> Tensorflow and Keras</b>
              </i> */}


Hey there, I'm Siddharth, currently pursuing B.Tech. in Data Science and Artificial Intelligence at the Indian Institute of Information Technology in Dharwad. Throughout my academic journey, I've delved deep into Data Structures, Machine Learning, and Database Management Systems, maintaining a GPA of 8.75. As a Gen AI Developer Intern at Bitloka Solutions, I led fine-tuning efforts for Language Model Models (LLMs) using Pinecone and LangChain while streamlining data integration pipelines with Apache Airflow.

During my stint as a Mitacs Globalink Research Intern at Saint Mary's University, I honed my skills in synthesizing complex datasets and crafting Spatio-Temporal Graph Social Networks.


<br/>
<br/>
 Not just limited to academia, I've ventured into diverse projects like MetaBorrow and FunTastic, where I explored blockchain integration and merged animation tech with education. Currently, my focus is on the Valence Aware AI Teaching Agent, collaborating to revolutionize Ed-Tech with multi-modal analysis techniques. My work in Bitcoin Evolution Analytics using Twitter sentiments was recognized in the IEEE International Conference on Big Data.
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/siddBhandari"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/siddharth-bhandari-7a5256201/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/siddharth_bhandari_10/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
